/* Alphonso Soft Minimal · small, dependency-free behaviours */
(function () {
  if (window.__awInit) return;
  window.__awInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cart (works with the base theme's offcanvas cart) ---------- */
  function updateBadges(count) {
    document.querySelectorAll('.cart-count-badge').forEach(function (b) { b.textContent = count; b.setAttribute('data-count', count); });
  }
  function syncCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateBadges(c.item_count); return c; }).catch(function () {});
  }
  function openCart() {
    var oc = document.getElementById('offcanvas-cart');
    if (oc && window.bootstrap && window.bootstrap.Offcanvas) { window.bootstrap.Offcanvas.getOrCreateInstance(oc).show(); return true; }
    return false;
  }
  function addToCart(id, qty) {
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', qty || 1);
    fd.append('sections', 'cart-count-badge,offcanvas-cart');
    fd.append('sections_url', window.location.pathname);
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Could not add to bag');
          return data;
        });
      })
      .then(function (data) {
        var cc = document.querySelector('cart-container');
        if (cc && data.sections && typeof cc.reloadCartElements === 'function') {
          cc.reloadCartElements(data.sections);
        }
        decorateCart();
        syncCount();
        window.dispatchEvent(new CustomEvent('aw:cart:added', { detail: data }));
        return data;
      });
  }
  window.awAddToCart = addToCart;

  // Adds a small, honest reassurance row under the checkout button.
  function decorateCart() {
    var foot = document.querySelector('#offcanvas-cart .offcanvas-footer');
    if (!foot || foot.querySelector('.aw-cart-trust')) return;
    var src = document.querySelector('[data-aw-cart-trust]');
    if (!src) return;
    var ul = document.createElement('ul');
    ul.className = 'aw-cart-trust';
    src.getAttribute('data-aw-cart-trust').split('|').forEach(function (t) { if (t.trim()) { var li = document.createElement('li'); li.textContent = t.trim(); ul.appendChild(li); } });
    foot.appendChild(ul);
  }
  window.addEventListener('kt.cart.reloaded', decorateCart);
  window.addEventListener('kt.cart.changed', function (e) { if (e.detail && typeof e.detail.item_count === 'number') updateBadges(e.detail.item_count); });

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-aw-quick-open]');
    if (plus) {
      var card = plus.closest('.aw-card');
      document.querySelectorAll('.aw-card.is-open').forEach(function (c) { if (c !== card) c.classList.remove('is-open'); });
      if (card) card.classList.add('is-open');
      var first = card && card.querySelector('.aw-size:not([disabled])');
      if (first) first.focus();
      return;
    }
    var closeQ = e.target.closest('[data-aw-quick-close]');
    if (closeQ) { closeQ.closest('.aw-card').classList.remove('is-open'); return; }

    var size = e.target.closest('[data-aw-quick-add]');
    if (size) {
      var label = size.closest('.aw-card').querySelector('[data-aw-quick-label]');
      size.disabled = true;
      size.classList.add('is-loading');
      addToCart(size.getAttribute('data-aw-quick-add'), 1).then(function () {
        size.disabled = false;
        size.classList.remove('is-loading');
        size.classList.add('is-added');
        if (label) label.textContent = 'Added ' + size.textContent.trim() + ' ✓';
        openCart();
      }).catch(function (err) {
        size.disabled = false;
        size.classList.remove('is-loading');
        if (label) label.textContent = err.message;
      });
      return;
    }
    var tab = e.target.closest('[data-aw-tab]');
    if (tab) {
      var group = tab.closest('[data-aw-tabs]');
      group.querySelectorAll('[data-aw-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      var target = tab.getAttribute('data-aw-tab');
      group.querySelectorAll('[data-aw-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-aw-panel') !== target; });
      var more = group.querySelector('[data-aw-tab-link]');
      if (more && tab.dataset.url) more.href = tab.dataset.url;
    }
    // Close open quick-add panels when clicking elsewhere
    if (!e.target.closest('.aw-card__sizes')) document.querySelectorAll('.aw-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.aw-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
  });

  /* ---------- Product form (aw-main-product) ---------- */
  function initProduct(form) {
    if (form.dataset.awReady) return;
    form.dataset.awReady = '1';
    var data = JSON.parse(form.querySelector('[data-aw-variants]').textContent);
    var idInput = form.querySelector('input[name="id"]');
    var price = document.querySelector('[data-aw-price="' + form.dataset.section + '"]');
    var cta = form.querySelector('[data-aw-add]');
    var label = form.querySelector('[data-aw-size-label]');
    var qtyInput = form.querySelector('[data-aw-qty]');
    var sticky = document.querySelector('[data-aw-sticky="' + form.dataset.section + '"]');
    var stickyBtn = sticky && sticky.querySelector('button');
    var stickyPrice = sticky && sticky.querySelector('[data-aw-sticky-price]');

    function selected() {
      return Array.prototype.map.call(form.querySelectorAll('[data-aw-option]'), function (group) {
        var c = group.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var sel = selected();
      var complete = sel.every(function (v) { return v !== null; });
      var variant = !complete ? null : (sel.length ? data.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) : data[0]);
      if (label) label.textContent = complete && sel.length ? sel[sel.length - 1] + ' selected' : 'choose one below';
      if (variant) {
        idInput.value = variant.id;
        if (price) price.textContent = variant.price_formatted;
        if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
        cta.disabled = !variant.available;
        cta.textContent = variant.available ? 'Add to cart · ' + variant.price_formatted : 'Sold out';
        if (stickyBtn) stickyBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      } else {
        // Stay tappable: a tap without a size runs the "pick a size" nudge instead of doing nothing.
        cta.disabled = false;
        cta.textContent = 'Select a size';
        if (stickyBtn) stickyBtn.textContent = 'Select a size';
      }
      form.querySelectorAll('[data-aw-option] input').forEach(function (inp) {
        // Mark sizes that are sold out for the current other selections
        var idx = Array.prototype.indexOf.call(form.querySelectorAll('[data-aw-option]'), inp.closest('[data-aw-option]'));
        var trial = sel.slice(); trial[idx] = inp.value;
        var ok = data.some(function (v) { return v.available && v.options.every(function (o, i) { return trial[i] === null || o === trial[i]; }); });
        inp.closest('.aw-opt__v') && inp.closest('.aw-opt__v').classList.toggle('is-out', !ok);
      });
    }
    form.addEventListener('change', update);
    form.querySelectorAll('[data-aw-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.awStep)));
      });
    });
    function nudgeSize() {
      if (label) label.textContent = 'please pick a size first';
      var fs = Array.prototype.find.call(form.querySelectorAll('[data-aw-option]'), function (g) { return !g.querySelector('input:checked'); }) || form.querySelector('[data-aw-option]');
      if (fs) {
        fs.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        fs.classList.remove('is-shake'); void fs.offsetWidth; fs.classList.add('is-shake');
      }
    }
    form.addEventListener('submit', function (e) {
      var complete = selected().every(function (v) { return v !== null; });
      if (e.submitter && e.submitter.hasAttribute('data-aw-buy-now')) {
        if (!complete) { e.preventDefault(); nudgeSize(); }
        return; // real submit → checkout
      }
      e.preventDefault();
      if (!complete) { nudgeSize(); return; }
      if (!idInput.value || cta.disabled) return;
      cta.disabled = true;
      cta.classList.add('is-loading');
      addToCart(idInput.value, parseInt(qtyInput.value, 10) || 1).then(function () {
        cta.disabled = false;
        cta.classList.remove('is-loading');
        cta.textContent = 'Added to cart ✓';
        openCart();
        setTimeout(update, 2200);
      }).catch(function (err) { cta.disabled = false; cta.classList.remove('is-loading'); cta.textContent = err.message; });
    });
    if (sticky && stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var complete = selected().every(function (v) { return v !== null; });
        if (!complete) { nudgeSize(); return; }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(cta); else cta.click();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
        }).observe(cta);
      }
    }
    update();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal(scope) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var els = (scope || document).querySelectorAll('.aw-head, .aw-card, .aw-tile, .aw-persona, .aw-pr__item, .aw-va__card, .aw-ch, .aw-why__row, .aw-soft, .aw-way, .aw-reveal-me');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < window.innerHeight) return; // already on screen: leave as is
      el.classList.add('aw-reveal');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
    // Safety net: never leave content hidden (fast jumps, anchors, printing)
    var ticking = false;
    function sweep() {
      ticking = false;
      document.querySelectorAll('.aw-reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.05) el.classList.add('is-in');
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    window.addEventListener('beforeprint', function () { document.querySelectorAll('.aw-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
  }

  function boot() {
    document.querySelectorAll('form[data-aw-product-form]').forEach(initProduct);
    initReveal();
    decorateCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { document.querySelectorAll('form[data-aw-product-form]').forEach(initProduct); initReveal(e.target); });
})();
